import { render, staticRenderFns } from "./tabAlarmNotification.vue?vue&type=template&id=25f27b05&scoped=true&"
import script from "./tabAlarmNotification.vue?vue&type=script&lang=js&"
export * from "./tabAlarmNotification.vue?vue&type=script&lang=js&"
import style0 from "./tabAlarmNotification.vue?vue&type=style&index=0&id=25f27b05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f27b05",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25f27b05')) {
      api.createRecord('25f27b05', component.options)
    } else {
      api.reload('25f27b05', component.options)
    }
    module.hot.accept("./tabAlarmNotification.vue?vue&type=template&id=25f27b05&scoped=true&", function () {
      api.rerender('25f27b05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/aviationExchangePriceBatch/tab/tabAlarmNotification.vue"
export default component.exports